import React, { useContext } from 'react';

import HeaderContext from './HeaderContext';
import HeaderNavMobileItem from './HeaderNavMobileItem';

const HeaderNavMobileSearch = () => {
  const { isSearchActive, setSearchActive, setActiveFlyout, closeMegaMenu } =
    useContext(HeaderContext);

  const handleClick = () => {
    setActiveFlyout(null);
    setSearchActive(true);
    closeMegaMenu();
  };

  return (
    <HeaderNavMobileItem
      icon={isSearchActive ? 'close' : 'search'}
      onClick={handleClick}
    >
      Search
    </HeaderNavMobileItem>
  );
};

export default HeaderNavMobileSearch;
